import { createRoot, hydrateRoot } from 'react-dom/client';
import { hydrate } from '@tanstack/react-query';
import App from './App.tsx';
import { queryClient } from './queryClient.ts';
import './index.css';

const rootElement = document.getElementById("root")!;
const isPrerendered = rootElement.hasAttribute('data-prerendered');

// Restore React Query state from prerendered data
if ((window as any).__REACT_QUERY_STATE__) {
  hydrate(queryClient, (window as any).__REACT_QUERY_STATE__);
  delete (window as any).__REACT_QUERY_STATE__;
}

if (isPrerendered) {
  hydrateRoot(rootElement, <App />);
} else {
  createRoot(rootElement).render(<App />);
}
